<table mat-table [dataSource]="itemList" class="mat-elevation gsm-ia-table">
  <!--Art Column-->
  <ng-container matColumnDef="art">
    <th mat-header-cell *matHeaderCellDef>Art *</th>
    <td mat-cell *matCellDef="let item">
      <input
        matInput
        name="art"
        type="text"
        maxlength="300"
        minlength="2"
        required
        gsmAlphanum
        data-test="ia-table_art-input"
        [(ngModel)]="item.art"
        [disabled]="model?.disabled"
        (blur)="onInputBlur()"
        #art="ngModel"
      />
    </td>
    <td mat-footer-cell *matFooterCellDef>SUMME</td>
  </ng-container>
  <!--Bezeichnung Column-->
  <ng-container matColumnDef="bezeichnung">
    <th mat-header-cell *matHeaderCellDef>Bezeichnung</th>
    <td mat-cell *matCellDef="let item">
      <input
        matInput
        name="bezeichnung"
        type="text"
        minlength="2"
        maxlength="300"
        gsmAlphanum
        data-test="ia-table_bezeichnung-input"
        [(ngModel)]="item.bezeichnung"
        [disabled]="model?.disabled"
        (blur)="onInputBlur()"
      />
    </td>
    <td mat-footer-cell *matFooterCellDef></td>
  </ng-container>
  <!--Anzahl Column-->
  <ng-container matColumnDef="anzahl">
    <th mat-header-cell *matHeaderCellDef>Anzahl</th>
    <td mat-cell *matCellDef="let item">
      <input
        matInput
        name="anzahl"
        type="number"
        maxlength="300"
        min="0"
        step="1"
        data-test="ia-table_anzahl-input"
        [pattern]="numberPattern"
        [(ngModel)]="item.anzahl"
        [disabled]="model?.disabled"
        (blur)="onInputBlur()"
      />
    </td>
    <td mat-footer-cell *matFooterCellDef></td>
  </ng-container>
  <!--Betrag Column-->
  <ng-container matColumnDef="betrag">
    <th mat-header-cell *matHeaderCellDef>Betrag [€] *</th>
    <td mat-cell *matCellDef="let item">
      €
      <input
        matInput
        name="betrag"
        type="number"
        maxlength="300"
        min="0"
        step="0.01"
        required
        data-test="ia-table_betrag-input"
        [(ngModel)]="item.summe"
        [disabled]="model?.disabled"
        (blur)="onInputBlur()"
      />
    </td>
    <td mat-footer-cell *matFooterCellDef>€ {{ totalSum | number: '1.2-2':'de-DE' }}</td>
  </ng-container>
  <!--Delete Column-->
  <ng-container matColumnDef="delete">
    <th mat-header-cell *matHeaderCellDef></th>
    <td mat-cell *matCellDef="let item; let i = index">
      <button mat-icon-button (click)="deleteItem(i)" *ngIf="!model?.disabled">
        <mat-icon>delete</mat-icon>
      </button>
    </td>
    <td mat-footer-cell *matFooterCellDef></td>
  </ng-container>
  <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
  <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
  <tr mat-footer-row *matFooterRowDef="displayedColumns"></tr>
</table>

<span class="add-item" *ngIf="!model?.disabled" data-test="gsm-ia-table_add" (click)="addItem()">
  <button mat-mini-fab color="primary">
    <mat-icon>add</mat-icon>
  </button>
  <span class="label">Weiteren Eintrag hinzufügen</span>
</span>
